/**
 * @file plural.ts
 * @description Русское склонение по числу (phase19.15 шаг 5).
 *
 * Раньше хелпер жил внутри `shipment-events-view.ts` — но склонение нужно и
 * диалогам заказа, и отчётам синхронизации, поэтому вынесен отдельным модулем:
 * импортировать «представление событий отгрузки» ради счётчика позиций было бы
 * связыванием ни о чём.
 */

/**
 * Форма слова по числу: `[1, 2-4, 5+]`.
 *
 * @example pluralRu(3, ["позиция", "позиции", "позиций"]) // «позиции»
 */
export function pluralRu(n: number, forms: [string, string, string]): string {
  const mod100 = n % 100;
  // 11-14 — исключение: «11 позиций», хотя последняя цифра 1..4.
  if (mod100 >= 11 && mod100 <= 14) return forms[2];
  const mod10 = n % 10;
  if (mod10 === 1) return forms[0];
  if (mod10 >= 2 && mod10 <= 4) return forms[1];
  return forms[2];
}
